import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { CLINIC } from '../mock';

export const FloatingContact = () => (
  <div data-testid="floating-contact" className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
    <a data-testid="floating-whatsapp-button" href={`${CLINIC.whatsapp}?text=${encodeURIComponent('Hello, I would like to book an appointment with Dr Puneet Srivastava.')}`} target="_blank" rel="noreferrer" aria-label="WhatsApp us"
      className="group relative grid place-items-center w-14 h-14 rounded-full text-white shadow-xl transition-transform duration-200 hover:scale-110" style={{ background: '#25D366' }}>
      <span className="absolute inset-0 rounded-full animate-ping opacity-25" style={{ background: '#25D366' }} />
      <MessageCircle size={26} className="relative" />
      <span className="absolute right-16 whitespace-nowrap bg-teal-950 text-white text-xs font-semibold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">WhatsApp us</span>
    </a>
    <a data-testid="floating-call-button" href={`tel:${CLINIC.phoneRaw}`} aria-label="Call the clinic"
      className="group relative grid place-items-center w-14 h-14 rounded-full text-white shadow-xl transition-transform duration-200 hover:scale-110" style={{ background: 'var(--coral)' }}>
      <Phone size={24} />
      <span className="absolute right-16 whitespace-nowrap bg-teal-950 text-white text-xs font-semibold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">{CLINIC.phone}</span>
    </a>
  </div>
);
